import { useNavigate } from "react-router-dom";
import React from "react";
import "../Styles/Feefrequency.css";

export default function FeeFrequenciesTable() {
  const navigate = useNavigate();

  const handleNavigate = (name) => {
    navigate(`/${name}`);
  };

  const data = [
    { id: 1, name: "Onetime", status: "Active" },
    { id: 2, name: "Monthly", status: "Active" },
    { id: 3, name: "Quaterly", status: "Active" },
    { id: 4, name: "Termwise", status: "Active" },
    { id: 5, name: "Yearly", status: "Active" },
    { id: 6, name: "Coursewise", status: "Active" },
  ];

  return (
    <div className="fee-container my-4">
      {/* Header */}
      <div className="special-header panel-white-all">
        <h4 className="page-title mt-1">Fee Frequencies</h4>
      </div>

      {/* Filter Section */}
      <div className="table-top-filters d-flex flex-wrap gap-3 ">
        <input
          type="text"
          className="form-control form-control-sm"
          placeholder="Fee Frequency Name"
          style={{ maxWidth: "200px" }}
        />
        <input
          type="text"
          className="form-control form-control-sm"
          placeholder="Fee Frequency Status"
          style={{ maxWidth: "200px" }}
        />
        <button type="button" className="btn custom-btn btn-sm">
          Clear
        </button>
      </div>

      {/* Table Section */}
      <div className="card">
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="custom-table">
              <thead>
                <tr>
                  <th>Sr No</th>
                  <th>Fee Frequency Name</th>
                  <th>Fee Frequency Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data.map((row) => (
                  <tr key={row.id}>
                    <td>{row.id}</td>
                    <td>{row.name}</td>
                    <td>{row.status}</td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-sm"
                        onClick={() => handleNavigate(row.name)}
                        title="View"
                      >
                        <i className="bi bi-eye"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
